<template>
  <div class="step-container">
    <div class="row center">
      <h3 class="step-header">1. Select property ownership type</h3>
    </div>
    <div class="row center">
      <h4 class="step-sub-header">Rented Properties need an additional gas inspection</h4>
    </div>
    <div class="row center">
      <button class="submit-button" @click="$emit('submit', 'homeowner')">
        <img class="btn-icon" :src="`${base}images/detached.png`" alt="homeowner icon">
        <span>Homeowner</span>
      </button>
      <button class="submit-button" @click="$emit('submit', 'landlord')">
        <img class="btn-icon" :src="`${base}images/flat-apartment.png`" alt="rented icon">
        <span>Rented</span>
      </button>
    </div>
    <div class="row center back">
      <span></span>
    </div>

  </div>
</template>

<script>
export default {
  name: "StepOne",
  props: {
    base: {
      type: String,
      required: true,
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/steps/StepOne.vue